import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatLabel, MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-filter',
    templateUrl: './filter.component.html',
    styleUrls: ['./filter.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, CdkScrollable, MatDialogContent, MatLabel, MatFormField, MatInput, MatDialogActions, MatButton]
})
export class FilterComponent implements OnInit {
  
  filterFormGroup:UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<FilterComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public inData: any
  ) { 
    this.filterFormGroup = this.fb.group({
      MinDuration: new UntypedFormControl({value: inData.minDuration, disabled: false}, Validators.required)
    });    
  }

  ngOnInit(): void {
  }

  filter() {

    this.dialogRef.close({minDuration: this.filterFormGroup.get('MinDuration').value});
  }

  onNoClick():void {
    console.log("Close");
    this.dialogRef.close({minDuration: 0});
  }

}
